import { useState, type FormEvent } from 'react'
import type { Page, CreatePageInput, UpdatePageInput } from '../model/contracts'
import { Button } from '../../../shared/ui/Button'

interface PageFormProps {
  page?: Page
  onSubmit: (data: CreatePageInput | UpdatePageInput) => void
  onCancel?: () => void
}

const PLATFORMS = [
  'Facebook',
  'Twitter',
  'Instagram',
  'LinkedIn',
  'TikTok',
  'YouTube',
  'Other',
]

export function PageForm({ page, onSubmit, onCancel }: PageFormProps) {
  const [name, setName] = useState(page?.name || '')
  const [url, setUrl] = useState(page?.url || '')
  const [platform, setPlatform] = useState(page?.platform || '')
  const [description, setDescription] = useState(page?.description || '')

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    if (!name.trim() || !url.trim() || !platform.trim()) return

    if (page) {
      onSubmit({ id: page.id, name, url, platform, description })
    } else {
      onSubmit({ name, url, platform, description })
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
    >
      <div>
        <label
          htmlFor="page-name"
          style={{ display: 'block', marginBottom: 8, fontSize: 14, fontWeight: 500 }}
        >
          Page Name *
        </label>
        <input
          id="page-name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          className="bg-input-overlay"
          style={{
            width: '100%',
            padding: '10px 12px',
            borderRadius: 8,
            border: '1px solid var(--panel-border)',
            color: 'var(--text)',
            fontSize: 14,
          }}
          placeholder="Enter page name"
        />
      </div>

      <div>
        <label
          htmlFor="page-url"
          style={{ display: 'block', marginBottom: 8, fontSize: 14, fontWeight: 500 }}
        >
          URL *
        </label>
        <input
          id="page-url"
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          required
          className="bg-input-overlay"
          style={{
            width: '100%',
            padding: '10px 12px',
            borderRadius: 8,
            border: '1px solid var(--panel-border)',
            color: 'var(--text)',
            fontSize: 14,
          }}
          placeholder="https://..."
        />
      </div>

      <div>
        <label
          htmlFor="page-platform"
          style={{ display: 'block', marginBottom: 8, fontSize: 14, fontWeight: 500 }}
        >
          Platform *
        </label>
        <select
          id="page-platform"
          value={platform}
          onChange={(e) => setPlatform(e.target.value)}
          required
          className="bg-input-overlay"
          style={{
            width: '100%',
            padding: '10px 12px',
            borderRadius: 8,
            border: '1px solid var(--panel-border)',
            color: 'var(--text)',
            fontSize: 14,
          }}
        >
          <option value="">Select platform</option>
          {PLATFORMS.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label
          htmlFor="page-description"
          style={{ display: 'block', marginBottom: 8, fontSize: 14, fontWeight: 500 }}
        >
          Description
        </label>
        <textarea
          id="page-description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={3}
          className="bg-input-overlay"
          style={{
            width: '100%',
            padding: '10px 12px',
            borderRadius: 8,
            border: '1px solid var(--panel-border)',
            color: 'var(--text)',
            fontSize: 14,
            resize: 'vertical',
            fontFamily: 'inherit',
          }}
          placeholder="Optional description"
        />
      </div>

      <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
        {onCancel && (
          <Button type="button" variant="neutral" onClick={onCancel}>
            Cancel
          </Button>
        )}
        <Button type="submit">{page ? 'Update' : 'Create'} Page</Button>
      </div>
    </form>
  )
}
